import React from 'react';
import { FormattedMessage } from 'react-intl';
import PositiveToast from '@/components/toasts/PositiveToast';

const DatasetConvertToast = ({ datasetName }) => (
  <PositiveToast className="aridhia-dataset-convert-toast">
    <FormattedMessage id="dataset.convert.toast.update.dictionaries" values={{ datasetName }} />
  </PositiveToast>
);

export default DatasetConvertToast;
